import { createI18n } from 'vue-i18n'
import ru from '@/lang/ru/ru'
import { reloadOnChunkError } from "@/services/chunkError.helper"
let lang = "ru"

// only russian (the starting locale) is bundled, the others are loaded when a clinic uses them (loadLanguage)
const loaders = {
    en: () => import('@/lang/en/en'),
    uk: () => import('@/lang/uk/uk'),
    uz: () => import('@/lang/uz/uz'),
    az: () => import('@/lang/az/az'),
    kz: () => import('@/lang/kz/kz'),
    kg: () => import('@/lang/kg/kg'),
}

// Russian and Ukrainian have 4 plural forms (today/one/few/many, e.g. "1 день", "2 дня", "5 дней").
// vue-i18n's default rule only supports 3 buckets, so translations that need the
// 4th ("many") form must provide 4 pipe-separated segments - for anything with
// fewer segments we fall back to the default rule to avoid breaking it.
const russianPluralRule = (choice, choicesLength, orgRule) => {
    if(choicesLength < 4) return orgRule(choice, choicesLength)
    if(choice === 0) return 0
    const mod10 = choice % 10
    const mod100 = choice % 100
    if(mod10 === 1 && mod100 !== 11) return 1
    if(mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 2
    return 3
}

const i18n = createI18n({
    locale: lang,
    messages: { ru },
    pluralizationRules: {
        ru: russianPluralRule,
        uk: russianPluralRule,
    },
})

// switches the locale, loading its messages first if needed; stays on the current one if they fail to load
export const loadLanguage = async (code) => {
    if(loaders[code] && !i18n.global.availableLocales.includes(code)) {
        try {
            i18n.global.setLocaleMessage(code, (await loaders[code]()).default)
        } catch(e) {
            reloadOnChunkError(e)
            return
        }
    }
    i18n.global.locale = code
}

export default i18n
